import { render, staticRenderFns } from "./SchoolSwitcher.vue?vue&type=template&id=76d5e167&scoped=true&"
import script from "./SchoolSwitcher.vue?vue&type=script&lang=js&"
export * from "./SchoolSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSwitcher.vue?vue&type=style&index=0&id=76d5e167&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d5e167",
  null
  
)

export default component.exports